import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { InputRadioList } from '@isyc-react/form/modules/input/option/radio';
import { OptionListDirection } from '@isyc-react/form/modules/input/option/base';
import { useMediaDevices } from "../../hooks";
import { MediaTrackType } from "../../view-model";
import { RippleButton } from '@isyc-react/form/modules/base/button';
import '@isyc-react/design/main';
export const MediaDevices = props => {
  const {
    audioInputDeviceId,
    audioOutputDeviceId,
    videoInputDeviceId,
    onChange,
    config = {
      audioInput: true,
      audioOutput: true,
      videoInput: true
    }
  } = props;
  const {
    audioInput = true,
    audioOutput = true,
    videoInput = true
  } = config;
  const {
    loading,
    devices,
    error,
    refetch
  } = useMediaDevices();
  React.useEffect(() => {
    const intervalId = setInterval(() => refetch(), 1000);
    return () => clearInterval(intervalId);
  }, []);
  const deviceToRadioItem = React.useCallback((kind, deviceId) => {
    const device = devices.find(device => device.deviceId === deviceId && device.kind === kind);
    return device ? {
      id: device.deviceId,
      checked: true,
      data: device
    } : null;
  }, [devices]);
  const devicesToRadioItems = React.useCallback(kind => {
    return devices.filter(device => device.kind === kind).reduce((accum, device) => {
      accum.items.push({
        id: device.deviceId,
        checked: false,
        data: device
      });
      accum.labels.push(device.label);
      return _objectSpread({}, accum);
    }, {
      items: [],
      labels: []
    });
  }, [devices]);
  const audioInputDevices = React.useMemo(() => devicesToRadioItems('audioinput'), [devicesToRadioItems]);
  const audioOutputDevices = React.useMemo(() => devicesToRadioItems('audiooutput'), [devicesToRadioItems]);
  const videoInputDevices = React.useMemo(() => devicesToRadioItems('videoinput'), [devicesToRadioItems]);
  return /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, loading && !devices ? /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spinner-border text-primary",
    role: "status"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, error ? /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-alert-circle-outline text-danger font-size-20 mb-2"
  }), /*#__PURE__*/React.createElement("div", null, "Error getting media devices"), /*#__PURE__*/React.createElement(RippleButton, {
    className: "btn btn-outline-primary mt-4",
    onClick: () => refetch()
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-sync"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ms-2"
  }, "Retry")))) : /*#__PURE__*/React.createElement(React.Fragment, null, videoInput && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center mb-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-camera text-primary font-size-20"
  }), /*#__PURE__*/React.createElement("h6", {
    className: "ms-2 mb-0"
  }, "Camera")), /*#__PURE__*/React.createElement(InputRadioList, {
    direction: OptionListDirection.VERTICAL,
    value: deviceToRadioItem('videoinput', videoInputDeviceId),
    onChange: selected => {
      onChange && onChange({
        type: MediaTrackType.VIDEO_INPUT,
        device: selected === null || selected === void 0 ? void 0 : selected.data
      });
    },
    items: videoInputDevices.items,
    labels: videoInputDevices.labels
  }), videoInputDevices.items.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: "p-2"
  }, "No devices"), (audioInput || audioOutput) && /*#__PURE__*/React.createElement("hr", {
    className: "border-primary",
    style: {
      opacity: '0.3'
    }
  })), audioInput && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center mb-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-microphone text-primary font-size-20"
  }), /*#__PURE__*/React.createElement("h6", {
    className: "ms-2 mb-0"
  }, "Microphone")), /*#__PURE__*/React.createElement(InputRadioList, {
    direction: OptionListDirection.VERTICAL,
    value: deviceToRadioItem('audioinput', audioInputDeviceId),
    onChange: selected => {
      onChange && onChange({
        type: MediaTrackType.AUDIO_INPUT,
        device: selected === null || selected === void 0 ? void 0 : selected.data
      });
    },
    items: audioInputDevices.items,
    labels: audioInputDevices.labels
  }), audioInputDevices.items.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: "p-2"
  }, "No devices"), audioOutput && /*#__PURE__*/React.createElement("hr", {
    className: "border-primary",
    style: {
      opacity: '0.3'
    }
  })), audioOutput && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center mb-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-speaker text-primary font-size-20"
  }), /*#__PURE__*/React.createElement("h6", {
    className: "ms-2 mb-0"
  }, "Speaker")), /*#__PURE__*/React.createElement(InputRadioList, {
    direction: OptionListDirection.VERTICAL,
    value: deviceToRadioItem('audiooutput', audioOutputDeviceId),
    onChange: selected => {
      onChange && onChange({
        type: MediaTrackType.AUDIO_OUTPUT,
        device: selected === null || selected === void 0 ? void 0 : selected.data
      });
    },
    items: audioOutputDevices.items,
    labels: audioOutputDevices.labels
  }), audioOutputDevices.items.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: "p-2"
  }, "No devices")))));
};